import type { FieldReadFunction, Reference } from '@apollo/client'

interface CachedWindow {
  data: readonly Reference[]
}

/**
 * Serves a `perPage`-sized prefix of a cached list. Belongs on a field whose `keyArgs` omit `perPage`,
 * where one entry holds every window and can be longer than the request being served.
 */
export const readPaginationWindow: FieldReadFunction<CachedWindow> = (existing, { args }) => {
  const perPage = args?.perPage

  if (!existing || typeof perPage !== 'number') {
    return existing
  }

  return { ...existing, data: existing.data.slice(0, perPage) }
}
